import BaseModel from './BaseModel'

export default class PromotionFilter extends BaseModel {
    defaults() {
        return {
            id          : undefined,
            type        : undefined,   // enum: NEW_REGISTER
            promotion_id: undefined,   // definido automaticamente via parent_link
            config      : {
                time_past: undefined, // recebe em minutos
            },
        }
    }
}